import React from "react"
import { connect } from "react-redux"
import { push } from "connected-react-router"
import {Toast} from "react-weui"
import Ajax from "superagent"
import { isNumber, keys, keyBy, isEmpty } from "lodash"


import { products}  from "../../../../data"
import Page from "../components/FixedBarPage"
import { updateProductData } from "../actions/index"
import { getSelections } from "../selectors"
import { getPrice } from "../CatalogoTools"
import {getType} from '../tags'

import './ReviewPage.less'
import describePriceAges from "./describePriceAges"


function createProductFromCar(car) {
  return {
    _id: 'car',
    name: car.display_name
  }
}

class ReviewPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      redirecting: false,
      starpay: {}
    }
  }

  componentDidMount() {
    Ajax.get(`/getRate?vendor=${this.props.userInfo.vendor}`).then(res => {
      this.setState({rate: res.body.rate})
    })
  }

  getBackUrl(step) {
    return `/catalogo/reservation/selections/${this.props.product._id}/${step}`
  }

  getAgePrice(agepersons, price) {    
    return keys(agepersons).map(key => agepersons[key] * keyBy(describePriceAges(price), 'key')[key].price).reduce((a, b) => a + b, 0)
  }

  eur2yuan(e) { return isNumber(e) ? e * this.state.rate : 0 }

  getTotalPrice() {
    const {menus, persons, price, agepersons} = this.props.productSelections
    if (price) return price
    if (menus.length > 0) return menus.map(menu => menu.count * this.props.product.menus[menu.id].price).reduce((a, b) => a + b, 0)
    else if (!isEmpty(agepersons)) {
      return this.getAgePrice(agepersons, this.props.product.price)
    }
    else return getPrice(this.props.product.price, persons)
  }

  submitAll() {
    this.setState({redirecting: true})
    const eurPrice = this.getTotalPrice()
    Ajax.post("/addreservation")
      .send({
        ...this.props.productSelections,
        ...this.props.userData,
        eurPrice,
        yuanPrice: this.eur2yuan(eurPrice),
        product: this.props.product,
        isCar: this.props.productSelections.selectedCar && true
      })
      .then((res) => {
        window.location = `/payment?id=${res.body.id}&price=${eurPrice}&vendor=${this.props.userInfo.vendor}`
        /* Ajax.get(`/payment?id=${res.body.id}&price=${eurPrice}&vendor=${this.props.userInfo.vendor}`)
          .then(() => console.log("Pago correcto?"))
          .catch(() => {
            this.setState({redirecting: false})
            alert("付款失败，请重试")
          }) */
      })
      .catch(() => {
        this.setState({redirecting: false})
        alert("付款失败，请重试")
      })
  }

  showTickets(price, age) {
    const arrayPrice = keyBy(describePriceAges(price), 'key')
    return <ul className="listPrice">
      {keys(age).map(key  => (<li key={key}>
        {arrayPrice[key].title}
        {' '}
(
        {age[key]} 
        {' '}
        {arrayPrice[key].price == 0 ? "gratis" : (`x ${arrayPrice[key].price}€`)}
)
      </li>))}
    </ul>
  }


  render() {
    const { product } = this.props

    return  (
      <Page
        title={product.chName || product.name}
        footerButton
        pillButton={false}
        onFooterClick={() => this.submitAll()}
        footerLabel="下一步"
        transparentBar
        containerProps={{ id: "ReviewPage" }}
      >
        <div id="ReviewPage">
          <div className="title">您的订单</div>

          <div className="resumen">

            <div className="subtitle">
              <p>预订信息</p>
            </div>

            <div className="reservationdata">

              {this.props.productSelections.selectedCar && (
                <React.Fragment>
                  <div className="minititle">
                    <p>汽车类型</p>
                    <img 
                      src="/static/edit.svg"
                      onClick={() => this.props.push('/catalogo/Madrid/transportation?step=showCarPicker')}
                    />
                  </div>
                  <p>
                    {this.props.productSelections.selectedCar.display_name}
                    {' '}
(
                    {this.props.productSelections.selectedCar.description}
)
                  </p>
                </React.Fragment>
              )}

              {this.props.productSelections.carsNumber && (
                <React.Fragment>
                  <div className="minititle">
                    <p>汽车数量</p>
                    <img 
                      src="/static/edit.svg"
                      onClick={() => this.props.push('/catalogo/Madrid/transportation?step=showCarPicker')}
                    />
                  </div>
                  <p>{this.props.productSelections.carsNumber}</p>
                </React.Fragment>
              )}
              
              <div className="minititle">
                <p>日期</p>
                <img 
                  src="/static/edit.svg"
                  onClick={() => this.props.push(this.props.productSelections.selectedCar ? '/catalogo/Madrid/transportation?step=showCarPicker' : this.getBackUrl('day'))}
                />
              </div>
              <p>{this.props.productSelections.day}</p>
              
              {this.props.productSelections.originAddress && (
                <React.Fragment>
                  <div className="minititle">
                    <p>原产地址</p>
                    <img 
                      src="/static/edit.svg"
                      onClick={() => this.props.push('/catalogo/Madrid/transportation?step=showOrigin')}
                    />
                  </div>
                  <p>{this.props.productSelections.originAddress}</p>
                </React.Fragment>
              )}

              {this.props.productSelections.destinationAddress && (
                <React.Fragment>
                  <div className="minititle">
                    <p>目的地址</p>
                    <img 
                      src="/static/edit.svg"
                      onClick={() => this.props.push('/catalogo/Madrid/transportation')}
                    />
                  </div>
                  <p>{this.props.productSelections.destinationAddress}</p>
                </React.Fragment>
              )}

              {this.props.productSelections.shift && (
                <React.Fragment>
                  <div className="minititle">
                    <p>预约时间</p>
                    <img 
                      src="/static/edit.svg"
                      onClick={() => this.props.push(this.getBackUrl('shift'))}
                    />
                  </div>
                  <p>{this.props.productSelections.shift}</p>
                </React.Fragment>
              )}
             
              
              {(this.props.productSelections.persons || this.props.productSelections.agepersons && !isEmpty(this.props.productSelections.agepersons)) && (
                <React.Fragment>
                  <div className="minititle">
                    <p>人数</p>
                    <img 
                      src="/static/edit.svg"
                      onClick={() => this.props.push(this.getBackUrl(this.props.productSelections.persons ? 'persons' : 'agePersons'))}
                    />
                  </div>

                  <p>{this.props.productSelections.persons}</p>
                  {this.props.productSelections.agepersons && !isEmpty(this.props.productSelections.agepersons) && this.showTickets(product.price, this.props.productSelections.agepersons)}
                </React.Fragment>
              )}
              
            </div>

            <div className="subtitle">
              <p>个人信息</p>
              <img 
                src="/static/edit.svg"
                onClick={() => this.props.push(`/catalogo/newformpage/${product._id}`)}
              />
            </div>
            
            <div className="reservationdata">
              <div className="minititle">姓名</div>
              <p>{this.props.userData.name}</p>
              <div className="minititle">电话号码</div>
              <p>
                {this.props.userData.prefix} 
                {' '}
                {this.props.userData.phone}
              </p>
              <div className="minititle">邮箱</div>
              <p>{this.props.userData.email}</p>
              {this.props.userData.comment && (
                <React.Fragment>
                  <div className="minititle">添加评论</div>
                  <p>{this.props.userData.comment}</p>
                </React.Fragment>
              )}
            </div>
            
            {this.props.productSelections.menus && this.props.productSelections.menus.length > 0 && (
              <React.Fragment>
                <div className="subtitle">
                  <p>选择菜单</p>
                  <img 
                    src="/static/edit.svg"
                    onClick={() => this.props.push(this.getBackUrl('menus'))}
                  />
                </div>

                <div className="list">
                  {this.props.productSelections.menus.filter(menu => menu.count > 0).map(menu => (
                    <div key={menu.id} className="product">
                      <div
                        className="image"
                        style={{
                          backgroundImage: `url(${product.menus[menu.id].background.image})`,
                        }}
                      />
                      <div className="texts">
                        <div className="productname">{product.menus[menu.id].chName}</div>
                        <div className="productdescription">{product.menus[menu.id].description}</div>
                        <div className="productcount">
                          <span className="count">{menu.count}</span>
                          <span className="x">x</span> 
                          <span className="productPrice">
                            {product.menus[menu.id].price}
€
                          </span>
                          <div className="prices">
                            <div className="euprice">
                              {product.menus[menu.id].price * menu.count}
€
                            </div>
                            <div className="yuanprice">
                              {this.eur2yuan(product.menus[menu.id].price * menu.count).toFixed(2)}
¥
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </React.Fragment>
            )}
            
            {this.props.productSelections.drinks && this.props.productSelections.drinks.length > 0 && (
              <React.Fragment>
                <div className="subtitle">
                  <p>饮料</p>
                  <img 
                    src="/static/edit.svg"
                    onClick={() => this.props.push(this.getBackUrl('drinks'))}
                  />
                </div>

                <div className="list">
                  {this.props.productSelections.drinks.filter(drink => drink.count > 0).map(drink => (
                    <div key={drink.id} className="product">
                      <div
                        className="image"
                        style={{
                          backgroundImage: `url(${product.drinks[drink.id].background.image})`,
                        }}
                      />
                      <div className="texts">
                        <div className="productname">{product.drinks[drink.id].chName}</div>
                        <div className="productdescription">{product.drinks[drink.id].description}</div>
                        <div className="productcount">
                          <span className="count">{drink.count}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </React.Fragment>
            )}
            
            <div className="totalPrice">
              <span>支付总额</span>
              <div className="totalCount">
                {this.getTotalPrice()}
                €/
                {this.eur2yuan(this.getTotalPrice()).toFixed(2)}
                ¥
              </div>
            </div>
          </div>
        </div>

        {this.state.redirecting && <Toast icon="loading" show>进入付款页面...</Toast>}
      </Page>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {id} = ownProps.match.params
  const product = id == 'car' ? createProductFromCar(state.transportation[ownProps.match.params.city].selectedCar) : products[id] || products[encodeURIComponent(id)]
  return {
    product,
    productSelections: getSelections(state, ownProps)[product._id] || state.transportation[ownProps.match.params.city] ||  {},
    userData: getSelections(state, ownProps).userData || {},
    userInfo: state.userInfo, 
  }
}

const mapDispatchToProps = dispatch => ({
  push: (url) => dispatch(push(url)),
  updateProductData: payload => dispatch(updateProductData(payload)),
})


export default connect(mapStateToProps, mapDispatchToProps)(ReviewPage)



// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/ReviewPage.jsx